type EventSwitchModalProps = {
  isApplying: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function EventSwitchModal({ isApplying, onCancel, onConfirm }: EventSwitchModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      data-testid="event-switch-modal"
    >
      <div className="w-full max-w-md rounded-xl bg-white p-6">
        <h2 className="text-xl font-semibold text-gray-900">Switch event?</h2>
        <p className="mt-2 text-sm text-gray-600">
          Opening this event link will switch your active event context and update when you joined.
        </p>
        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700"
            data-testid="event-switch-cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isApplying}
            className="flex-1 rounded-lg bg-pink-600 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50"
            data-testid="event-switch-confirm"
          >
            Switch event
          </button>
        </div>
      </div>
    </div>
  );
}
